import {MeshButtonDBType, MeshButtonType} from "../../components/annotations/ts/ButtonsTypes";
import * as THREE from "three";

export const  MeshButtonsDB: Array<MeshButtonDBType> = [

    //  {
    //     button_id: 'ARM_THE_P064',
    //     meshButtonType: MeshButtonType.BasicMeshButton,
    //     useOutliner: true,
    //     // outlinerColor: new THREE.Color(0x0000FF),
    //     outlinerColor: new THREE.Color(0xFFFFFF),
    // },

     {
        button_id: 'NANDEPW127',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },

    {
        button_id: 'SID_SID_B208',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'SID_SID_B209',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'SID_SID_B210',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'SID_SID_B211',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'SID_SID_B212',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'SID_SID_B213',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'SID_SID_B214',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'SID_SID_B215',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'SID_SID_B216',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },

    {
        button_id: 'RTG_RTG_V224',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },

    // {
    //     button_id: '',
    //     meshButtonType: MeshButtonType.BasicMeshButton,
    //     useOutliner: true,
    //     // outlinerColor: new THREE.Color(0x0000FF),
    //     outlinerColor: new THREE.Color(0xFFFFFF),
    // },


]
